package cc.easyandroid.easycompose.mvi.rx.internal

import cc.easyandroid.easycompose.mvi.rx.Observer
import cc.easyandroid.easycompose.mvi.utils.internal.InternalMviKotlinApi
import kotlin.concurrent.Volatile

interface BehaviorSubject<T> : Subject<T> {

    val value: T
}

@Suppress("FunctionNaming") // https://github.com/detekt/detekt/issues/6601
fun <T> BehaviorSubject(initialValue: T): BehaviorSubject<T> =
    BehaviorSubjectImpl(initialValue)

@OptIn(InternalMviKotlinApi::class)
private class BehaviorSubjectImpl<T>(initialValue: T) : BaseSubject<T>(), BehaviorSubject<T> {

    @Volatile
    override var value: T = initialValue
        private set

    override fun onAfterSubscribe(observer: Observer<T>) {
        super.onAfterSubscribe(observer)

        observer.onNext(value)
    }

    override fun onBeforeNext(value: T) {
        super.onBeforeNext(value)

        this.value = value
    }
}
